<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>
          <page-title title="Thank you" />
          <hr />

          <content-block slug="client-final" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ClientFinal',
  props: [
    'formId'
  ]
}
</script>